// ============================================
// File: src/components/ImageModal.js
// ============================================
import React, { useEffect } from 'react';

const ImageModal = ({ image, onClose, currentLang }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  const getTitle = () => {
    return currentLang === 'ar' ? image.titleAr : image.titleEn;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={onClose}>
        <div className="modal-content">
          <div className="modal-image">
            <img src={image.url} alt={getTitle()} />
          </div>
        </div>
      </div>
      
      <style>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.95);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: fadeIn 0.3s ease;
          cursor: pointer;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .modal-container {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        
        .modal-content {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
        }
        
        .modal-image {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
        
        .modal-image img {
          max-width: 90%;
          max-height: 85vh;
          width: auto;
          height: auto;
          object-fit: contain;
          border-radius: 16px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
          cursor: pointer;
          transition: transform 0.2s ease;
        }
        
        .modal-image img:active {
          transform: scale(0.98);
        }
        
        /* للشاشات الكبيرة (كمبيوتر) */
        @media (min-width: 1024px) {
          .modal-image img {
            max-width: 85%;
            max-height: 85vh;
          }
        }
        
        /* للشاشات المتوسطة (تابلت) */
        @media (min-width: 768px) and (max-width: 1023px) {
          .modal-image img {
            max-width: 88%;
            max-height: 85vh;
          }
        }
        
        /* للشاشات الصغيرة (جوال) */
        @media (max-width: 767px) {
          .modal-overlay {
            padding: 0.5rem;
          }
          
          .modal-image img {
            max-width: 95%;
            max-height: 80vh;
          }
        }
        
        /* للشاشات الصغيرة جداً */
        @media (max-width: 480px) {
          .modal-image img {
            max-width: 98%;
            max-height: 75vh;
            border-radius: 12px;
          }
        }
        
        /* للشاشات الأفقية على الجوال */
        @media (max-width: 768px) and (orientation: landscape) {
          .modal-image img {
            max-height: 75vh;
          }
        }
        
        /* للشاشات الكبيرة جداً (4K) */
        @media (min-width: 1600px) {
          .modal-image img {
            max-width: 75%;
            max-height: 80vh;
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          .modal-overlay,
          .modal-image img {
            animation: none;
            transition: none;
          }
        }
      `}</style>
    </div>
  );
};

export default ImageModal;